/**
 * Отрисовка маршрута внутри карты.
 *
 * Ломаная кладётся в `<g id="route">` координатами как есть: в графе
 * они уже в системе `viewBox` карты, пересчитывать нечего. Группа
 * последняя в документе, поэтому маршрут рисуется поверх всего.
 *
 * Маршрут живёт внутри SVG и при зуме и панорамировании едет вместе с
 * картой сам — контейнер двигается CSS-трансформацией, и трогать её не
 * нужно.
 *
 * Модуль ставит классы и не задаёт ни цветов, ни толщин: вид маршрута
 * описан в таблице стилей внутри самой карты. Иначе цвет оказался бы
 * зашит в двух местах независимо и однажды разошёлся.
 */

const SVG_NS = 'http://www.w3.org/2000/svg';

/** Доля большей стороны карты, дающая радиус меток концов. */
const END_MARK_RATIO = 150;

function findGroup(svgEl) {
  return svgEl ? svgEl.querySelector('#route') : null;
}

function polyline(points, className) {
  const el = document.createElementNS(SVG_NS, 'polyline');
  el.setAttribute('class', className);
  el.setAttribute('points', points.map((p) => `${p.x},${p.y}`).join(' '));
  return el;
}

function circle(point, className, radius) {
  const el = document.createElementNS(SVG_NS, 'circle');
  el.setAttribute('class', className);
  el.setAttribute('cx', point.x);
  el.setAttribute('cy', point.y);
  el.setAttribute('r', radius);
  return el;
}

/**
 * Хвост вырожден, если объект стоит вплотную к проходу (`dist: 0`):
 * обе точки совпадают, и polyline нарисовала бы точку.
 */
function isDegenerate(tail) {
  if (!tail || tail.length < 2) return true;
  const [first] = tail;
  const last = tail[tail.length - 1];
  return first.x === last.x && first.y === last.y;
}

function endMarkRadius(svgEl) {
  const box = svgEl.viewBox && svgEl.viewBox.baseVal;
  if (!box || !box.width || !box.height) return 1;
  return Math.max(box.width, box.height) / END_MARK_RATIO;
}

/** Стирает нарисованный маршрут. Карту не трогает. */
export function clearRoute(svgEl) {
  const group = findGroup(svgEl);
  if (!group) return false;

  group.replaceChildren();
  return true;
}

/**
 * Рисует маршрут, стирая прежний.
 * @param {SVGElement} svgEl корневой <svg> открытой карты
 * @param {Object} route результат router.route()
 * @returns {Boolean} нарисован ли
 */
export function drawRoute(svgEl, route) {
  const group = findGroup(svgEl);
  if (!group) return false;

  group.replaceChildren();
  if (!route || !route.points || route.points.length < 2) return false;

  const radius = endMarkRadius(svgEl);
  const parts = [];

  if (route.line && route.line.length > 1) {
    parts.push(polyline(route.line, 'route-line'));
  }
  if (!isDegenerate(route.startTail)) {
    parts.push(polyline(route.startTail, 'route-tail'));
  }
  if (!isDegenerate(route.endTail)) {
    parts.push(polyline(route.endTail, 'route-tail'));
  }

  parts.push(circle(route.points[0], 'route-start', radius));
  parts.push(circle(route.points[route.points.length - 1], 'route-end', radius));

  group.append(...parts);
  return true;
}
